import { medias } from '@/utils/sizes';
import styled from 'styled-components';

export const GallerySliderModal = styled.div`
  --gallery-slider-modal-pd: 4vh;
  --gallery-slider-side-width: 250px;

  position: fixed;
  display: grid;
  grid-template-columns: var(--gallery-slider-side-width) auto var(
      --gallery-slider-side-width
    );
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: var(--gallery-slider-modal-pd);
  background-color: var(--bg-main);
  align-items: center;
  z-index: 1000;
  overflow: hidden;
  touch-action: 'pan-y';
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  animation: fade-in 0.3s ease-in-out;

  .gallery-slider-img {
    pointer-events: none !important;
  }

  &:has(div[data-side='right'][data-display='true']) {
    .nav-listener-right {
      opacity: 0;
      pointer-events: none;
    }
  }

  &:has(div[data-side='left'][data-display='true']) {
    .nav-listener-left {
      opacity: 0;
      pointer-events: none;
    }
  }

  .gallery-link-project {
    z-index: 1000;
  }

  &[data-displayed-on-load='true'] {
    animation: fade-in 0.1s ease-in-out;
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  ${medias.max.desktopSm} {
    grid-template-columns: 100%;
    padding: 0;
    padding-top: 4vh;

    & {
      --gallery-slider-modal-pd: 4vh var(--page-pd-mobile-tablet);
    }
  }

  ${medias.max.tablet} {
    & {
      --gallery-slider-modal-pd: var(--page-pd-mobile-tablet)
        var(--page-pd-mobile-tablet);
    }
  }

  .close-btn,
  .zoom-in-btn {
    --close-btn-pos: calc(5vh - 25px);
    position: absolute;
    height: 50px;
    width: 50px;
    top: 4vh;
    right: 4vh;
    transform: translate(15px, -15px);
    z-index: 100000000;

    ${medias.max.mobile} {
      right: var(--page-pd-mobile-tablet);
    }

    img {
      opacity: 0.75;
    }
  }

  .zoom-in-btn {
    cursor: pointer;
    right: calc(4vh + 50px);
    height: 45px;
    width: 45px;
    z-index: 1000;

    img {
      padding-top: 3px;
      height: 35px;
      width: 35px;
      opacity: 0.9 !important;
    }

    &:hover img {
      opacity: 1;
      transform: scale(1.03);
    }
  }

  .gallery-slider-video-container {
    width: 100%;
    height: 100%;
  }

  .vimeo-video-container {
    width: 100%;
    height: 100%;

    ${`${medias.max.desktopSm} and (orientation: landscape)`} {
      height: auto;
      width: calc(100vw - 100px);
      left: 50px;

    }
  }

  &[data-is-displayed='false'] {
    opacity: 0;
    pointer-events: none;
  }

  .title {
    align-self: flex-start;
    grid-row: 1;
    grid-column: 1;

    ${medias.max.desktopSm} {
      left: 2vw;
      position: absolute;
    }

    ${medias.max.mobile} {
      padding: 0 var(--page-pd-mobile-tablet);
    }
  }

  img.gallery-slider-img {
    width: auto !important;
    object-fit: contain !important;
    transition: opacity 0.3s ease-in-out, transform var(--tr-base);

    ${medias.max.tablet} {
      width: 100vw !important;
    }
  }
`;

export const IconButton = styled.div`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  padding: 5px;
  border-radius: 10px;
  z-index: 2000000;

  svg {
    height: 45px;
    width: 45px;
  }

  ${medias.max.tablet} {
    opacity: 0.7 !important;

    svg {
      height: 35px;
      width: 35px;
    }
  }
`;

export const NavListenerLeft = styled.button`
  all: unset;
  cursor: pointer !important;
  position: absolute;
  top: 0;
  left: 0;
  width: 50vw;
  height: 100%;
  background: transparent;
  z-index: 100000;

  &[data-is-hidden='true'] {
    opacity: 0;
    pointer-events: none;
  }

  ${IconButton} {
    cursor: pointer;
    height: 45px;
    width: 45px;
    position: absolute;
    top: 50%;
    left: -5px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.4;
    transform: translate(0, -50%);
    transition:
      opacity var(--tr-base),
      transform var(--tr-base);
  }

  &:hover ${IconButton}  {
    opacity: 1;
    /* transform: translate(0, -50%); */
  }

  ${medias.max.desktopSm} {
    /* pointer-events: none; */
    height: 50px;
    width: 50px;
    top: 50%;
    transform: translateY(-50%);
  }

  ${medias.max.mobile} {
    top: unset;
    transform: unset;
    bottom: 75px;

    ${IconButton} svg {
      height: 25px;
      width: 25px;
    }
  }
`;

export const NavListenerRight = styled.button`
  all: unset;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  background: transparent;
  z-index: 100000;

  &[data-is-hidden='true'] {
    opacity: 0;
    pointer-events: none;
  }

  ${IconButton} {
    height: 45px;
    width: 45px;
    position: absolute;
    top: 50%;
    right: -10px;
    opacity: 0.4;
    transform: translate(0, -50%);
    transition:
      opacity var(--tr-base),
      transform var(--tr-base);

   ${IconButton} svg {
      height: 45px;
      width: 45px;
    }
  }

  ${medias.min.desktopSm} {
    &:hover ${IconButton} {
      opacity: 1;
    }

    ${IconButton} {
      opacity: 1;
    }
  }

  ${medias.max.tablet} {
    /* pointer-events: none; */
    height: 50px;
    width: 50px;
    top: 50%;
    transform: translateY(-50%);
  }

  ${medias.max.mobile} {
    top: unset;
    transform: unset;
    bottom: 75px;

    ${IconButton} svg {
      height: 25px;
      width: 25px;
    }
  }
`;

export const VideoWrapper = styled.div`
  position: relative;
  display: flex;

  &[data-display='true'] {
    z-index: 10000 !important;
  }

  @media (orientation: landscape) {
    width: 80vw;
  }
`;

export const ImagesContainer = styled.div`
  position: relative;
  grid-column: 1 / 4;
  grid-row: 1;
  height: 84vh;
  width: 100%;
  transition: opacity var(--tr-base);

  ${medias.min.desktopSm} {
    ${VideoWrapper}[data-display='true'],
    img[data-display='true'] {
      opacity: 1;
    }
    ${VideoWrapper}[data-display='false'],
    img[data-display='false'] {
      opacity: 0;
    }
  }

  &[data-is-end='true'] {
    opacity: 0.55;
  }

  img {
    cursor: zoom-in;
    max-width: 100%;
    max-height: 100%;
    width: auto !important;
    height: auto !important;
    object-fit: unset !important;
  }
`;

export const ImagesWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: transform var(--tr-base);

  ${medias.max.tablet} {
    flex-direction: row;
    flex-wrap: nowrap;
    overflow: visible;
    width: calc(100vw * var(--slider-num-img));
    transition: transform var(--tr-base);
    transform: translateX(calc(var(--transform-slider-mobile) * -100vw));

    ${VideoWrapper},
    img {
      position: relative !important;
      opacity: 1;
      width: 100vw !important;
      max-height: 87vh;
      object-fit: contain !important;
      margin: 0;
    }
  }

  ${medias.min.desktopSm} {
    ${VideoWrapper},
    img:not(.vimeo-poster) {
      position: absolute;
      top: 0 !important;
      left: 50% !important;
      transform: translateX(-50%);
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
      object-position: center;
    }
  }

  img.vimeo-poster {
    width: auto !important;
    height: 100% !important;
    object-fit: contain !important;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%);
  }
`;


export const ImageCounter = styled.div`
  display: inline-block;
  position: absolute;
  bottom: var(--gallery-slider-modal-pd);
  left: var(--gallery-slider-modal-pd);
  transform: translateY(100%);
  touch-action: 'pan-y';

  .typography {
    display: inline-block;
  }

  ${medias.max.desktopSm} {
    transform: translateY(-100%);
    left: 2vw;
    align-self: flex-end;
  }

  ${medias.max.mobile} {
    left: var(--page-pd-mobile-tablet);
  }
`;

export const NextPrevContainer = styled.div`
  cursor: pointer;
  box-sizing: content-box;
  pointer-events: none;
  position: absolute;
  left: 20px;
  width: var(--gallery-slider-side-width);
  padding: var(--spacing-component-inner);
  padding-left: 0;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  background: var(--bg-main);
  transition: opacity var(--tr-base) ease-in-out;

  a {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-component-inner-xs);

    > div {
      width: 100%;
    }
  }

  &[data-side='right'] {
    left: unset;
    right: 20px;
    padding-right: 0;
    padding-left: var(--spacing-component-inner);

    a {
      align-items: flex-end;

      p {
        text-align: right;
      }
    }
  }

  &[data-display='true'] {
    pointer-events: all;
    opacity: 1;
  }

  ${medias.max.mobile} {
    --gallery-slider-side-width: 167px;
  }

  ${medias.max.tablet} {
    left: 0;
    padding-left: var(--page-pd-mobile-tablet);

    &[data-side='right'] {
      right: 0;
      padding-right: var(--page-pd-mobile-tablet);
    }

    p {
      padding: 0 5px var(--page-pd-mobile-tablet) 5px;
    }
  }
`;

export const ScrollIndicatorContainer = styled.div`
  position: absolute;
  width: 100vw;
  height: 4px;
  bottom: 0;
  left: 0;
  background: var(--c-border);
`;

export const ScrollIndicator = styled.div`
  position: absolute;
  height: 100%;
  width: 100vw;
  background: var(--c-font-primary);
  left: 0;
  top: 0;
  transition: transform var(--tr-base);
  transform: scaleX(var(--scroll-percent));
  transform-origin: left;
`;

export const LinksContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 5px;  
  z-index: 1000;

  .gallery-link-image {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease-in-out;
  }

  &:hover .gallery-link-image {
    opacity: 1;
    pointer-events: all;
  }

`